import { FieldOperationSortFieldName } from '../ui/field-operations.types';

export const FIELD_OPERATIONS_SORT_FIELD: Record<string, FieldOperationSortFieldName> = {
  installationDateTime: FieldOperationSortFieldName.InstallationDateTimeUtc,
  installedBy: FieldOperationSortFieldName.InstalledBy,
  wakeupDateTime: FieldOperationSortFieldName.WakeupDateTimeUtc,
  initialReadDateTime: FieldOperationSortFieldName.InitialReadDateTimeUtc,
  mtuDeviceLabel: FieldOperationSortFieldName.CommDeviceId,
  installationReason: FieldOperationSortFieldName.InstallationReason
};
